const qualityswiper = new Swiper(".topQuality__sliderArea", {
	centeredSlides: true,
	loop: true,
	speed: 500,
	autoplay: {
		delay: 2400,
	},
	slidesPerView: 1,
	spaceBetween: 10,
	breakpoints: {
		480: {
			slidesPerView: 'auto',
			// slidesPerView: 2.5,
			spaceBetween: 0, // marginはscaleの縮小で自然に生まれるので0
		},
		2000: {
			// loopedSlides: 5,
			slidesPerView: 'auto',
			// slidesPerView: 4.5,
			spaceBetween: 0,
		}
	},
	navigation: {
		nextEl: ".topQuality__button--next",
		prevEl: ".topQuality__button--prev",
	},

});

const voiceswiper = new Swiper(".topVoice__sliderArea", {
	loop: true, // ループさせる
	speed: 500, // 少しゆっくり(デフォルトは300)
	navigation: {
		nextEl: ".topVoice__button--next",
		prevEl: ".topVoice__button--prev",
	},
});

document.querySelectorAll(".topVoice__sliderArea .swiper-slide")
	.forEach((slide) => {
		const baloon = slide.querySelector(".topVoice__baloon");
		if (baloon) {
			// data-swiper-slide-index は0始まりなので +1
			const index = parseInt(slide.dataset.swiperSlideIndex) + 1;
			baloon.textContent = `case${index}`;
		}
	});

jQuery(function ($) {
	//MV表示切り替え
	const videoDir = myThemeData.tmplUrl + '/img/top/';

	const videoSources = [{
			query: '(min-width:481px)',
			src: videoDir + 'top_pc.mp4' // PC用
		},
		{
			query: '(max-width:480px)',
			src: videoDir + 'top_sp.mp4' // SP用
		}
	];

	function movieSwitch() {
		const video = $('#mv');
		const matched = videoSources.find(({
			query
		}) => window.matchMedia(query).matches);

		if (!matched) return;

		if (video.attr('src') !== matched.src) {
			video.attr('src', matched.src);
			video[0].load();
		}
	}

	$(window).on('load', function () {
		movieSwitch();
	});

	// 画面幅が変わったとき（PC⇔SP切り替わり）にも動画を切り替える
	$(window).on('resize', function () {
		movieSwitch();
	});
});